import React from 'react';
import FlatButton from 'material-ui/FlatButton';

import { Link, withRouter } from 'react-router-dom';
import 'jquery-slimscroll/jquery.slimscroll.min';
import * as ROLES_CONFIG from '../../config/roles';

//store
import { store } from '../../stores/configureStore';

//action
import { toggleLoader } from '../../actions';

class SidebarContent extends React.Component {

  allowed_menu = {};
  constructor(props) {
    super(props);
    if (this.props.authenticated && this.props.authenticated.role) {
      this.checkRolePermissions(this.props.authenticated.role);
    }
  }

  checkRolePermissions(role) {
    for (let i in ROLES_CONFIG) {

      let c = 0;
      for (let j in ROLES_CONFIG[i]) {
        if (ROLES_CONFIG[i][j].constructor === Array && ROLES_CONFIG[i][j].indexOf(role) == -1) {
          c++;
        }
        else {
          if (ROLES_CONFIG[i].multilevel) {
            this.allowed_menu[j] = 1;
          }
        }
      }
      if (c != Object.keys(ROLES_CONFIG[i]).length && !ROLES_CONFIG[i].multilevel) {
        this.allowed_menu[i] = 1;
      }
      if (c != Object.keys(ROLES_CONFIG[i]).length - 1 && ROLES_CONFIG[i].multilevel) {
        this.allowed_menu[i] = 1;
      }
    }
  }

  componentDidMount() {
    const { history } = this.props;
    const nav = this.nav;
    const $nav = $(nav);

    // scroll
    $nav.slimscroll({
      height: '100%'
    });


    // Append icon to submenu
    // Append to child `div`
    $nav.find('.prepend-icon').children('div').prepend('<i class="material-icons">keyboard_arrow_right</i>');


    // AccordionNav
    const slideTime = 250;
    const $lists = $nav.find('ul').parent('li');
    $lists.append('<i class="material-icons icon-has-ul">arrow_drop_down</i>');
    const $As = $lists.children('a');

    // Disable A link that has ul
    $As.on('click', event => event.preventDefault());

    // Accordion nav
    $nav.on('click', (e) => {
      const target = e.target;
      const $parentLi = $(target).closest('li'); // closest, insead of parent, so it still works when click on i icons
      if (!$parentLi.length) return; // return if doesn't click on li
      const $subUl = $parentLi.children('ul');


      // let depth = $subUl.parents().length; // but some li has no sub ul, so...
      const depth = $parentLi.parents().length + 1;

      // filter out all elements (except target) at current depth or greater
      const allAtDepth = $nav.find('ul').filter(function () {
        if ($(this).parents().length >= depth && this !== $subUl.get(0)) {
          return true;
        }
        return false;
      });

      allAtDepth.slideUp(slideTime).closest('li').removeClass('open');

      // Toggle target
      if ($parentLi.has('ul').length) {
        $parentLi.toggleClass('open');
      }
      $subUl.stop().slideToggle(slideTime);

    });

    // HighlightActiveItems
    const $links = $nav.find('a');
    const currentLocation = history.location;

    function highlightActive(pathname) {
      const path = `#${pathname}`;

      $links.each((i, link) => {
        const $link = $(link);
        const $li = $link.parent('li');
        const href = $link.attr('href');
        // console.log(href);

        if ($li.hasClass('active')) {
          $li.removeClass('active');
        }
        if (path.indexOf(href) === 0) {
          $li.addClass('active');
        }
      });
    }

    highlightActive(currentLocation.pathname);
    history.listen((location) => {
      highlightActive(location.pathname);
    });
  }

  _handleClick(e) {
    store.dispatch(toggleLoader(true));
  }

  render() {
    return (
      <ul className="nav" ref={(c) => { this.nav = c; }}>
        <li className="nav-header"><span>Navigation</span></li>
        {
          this.allowed_menu['dashboard'] ? 
            <li>
              <FlatButton 
                onClick={this._handleClick.bind(this)} 
                href="#/app/dashboard"
              >
                <i className="nav-icon material-icons">
                  dashboard
                </i>

                <span className="nav-text">
                  Dashboard
                </span>
              </FlatButton>
            </li> 
          : null
        }

        {
          this.allowed_menu['rooms'] ?
            <li>
              <FlatButton href="#/app/rooms">
                <i className="nav-icon material-icons">
                  room
                </i>

                <span className="nav-text">
                  Rooms Manager
                </span>
              </FlatButton>

              <ul>
                {
                  this.allowed_menu['roomList'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        className="prepend-icon" 
                        href="#/app/rooms/list"
                      >
                        <span>
                          Rooms
                        </span>
                      </FlatButton>
                    </li> 
                  : null
                }

                {
                  this.allowed_menu['roomsConsolidated'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        className="prepend-icon" 
                        href="#/app/rooms/consolidated"
                      >
                        <span>
                          Room Control
                        </span>
                      </FlatButton>
                    </li> 
                  : null
                }
              </ul>
            </li> 
          : null
        }

        {
          this.allowed_menu['stats'] ? 
            <li>
              <FlatButton href="#/app/stats">
                <i className="nav-icon material-icons">
                  insert_chart
                </i>

                <span className="nav-text">
                  Stats
                </span>
              </FlatButton>

              <ul>
                {
                  this.allowed_menu['powerCharts'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        href="#/app/stats/power" 
                        className="prepend-icon"
                      >
                        Power Consumption
                      </FlatButton>
                    </li> 
                  : null
                }

                {
                  this.allowed_menu['checkinStats'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        href="#/app/stats/checkin" 
                        className="prepend-icon"
                      >
                        Checkin Stats
                      </FlatButton>
                    </li> 
                  : null
                }
              </ul>
            </li> 
          : null
        }

        {
          this.allowed_menu['services'] || this.allowed_menu['directory'] || this.allowed_menu['food'] ? 
            <li>
              <FlatButton href="#/app/services">
                <i className="nav-icon material-icons">
                  settings
                </i>

                <span className="nav-text">
                  Services
                </span>
              </FlatButton>

              <ul>
                {
                  this.allowed_menu['requests'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        className="prepend-icon" 
                        href="#/app/services/requests/all"
                      >
                        <span>
                          Service Requests
                        </span>
                      </FlatButton>
                    </li> 
                  : null
                }
                 {/* {
                  this.allowed_menu['requests'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        className="prepend-icon" 
                        href="#/app/services/alerts"
                      >
                        <span>
                          Intrusion Alerts
                        </span>
                      </FlatButton>
                    </li> 
                  : null
                } */}

                {
                  this.allowed_menu['manage'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        className="prepend-icon" 
                        href="#/app/services/manage"
                      >
                        <span>
                          Manage Services
                        </span>
                      </FlatButton>
                    </li> 
                  : null
                }

                {
                  this.allowed_menu['service_crud'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        className="prepend-icon" 
                        href="#/app/services/crud"
                      >
                        <span>
                          Manage Services
                        </span>
                      </FlatButton>
                    </li> 
                  : null
                }

                {
                  this.allowed_menu['service_assign_button'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        className="prepend-icon" 
                        href="#/app/services/btn"
                      >
                        <span>
                          Manage Service Buttons
                        </span>
                      </FlatButton>
                    </li> 
                  : null
                }

                {
                  this.allowed_menu['directory'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        href="#/app/directory" 
                        className="prepend-icon"
                      >
                        Telephone Directory
                      </FlatButton>
                    </li> 
                  : null
                }
                  {
                  this.allowed_menu['wifi'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        href="#/app/wifi" 
                        className="prepend-icon"
                      >
                       Wifi Management
                      </FlatButton>
                    </li> 
                  : null
                }


                {
                  this.allowed_menu['food'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        href="#/app/food" 
                        className="prepend-icon"
                      >
                        Food Menu
                      </FlatButton>
                    </li> 
                  : null
                }

                 {
                  this.allowed_menu['lock'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        href="#/app/movelock" 
                        className="prepend-icon"
                      >
                        Transfer Locks
                      </FlatButton>
                    </li> 
                  : null
                }
              </ul>
            </li> 
          : null
        }

        {
          this.allowed_menu['feedback'] ?
            <li>
              <FlatButton href="#/app/feedback">
                <i className="nav-icon material-icons">
                  feedback
                </i>

                <span className="nav-text">
                  Feedback
                </span>
              </FlatButton>

              <ul>
                {
                  this.allowed_menu['newFeedbackTemplate'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        className="prepend-icon" 
                        href="#/app/feedback/templates/create"
                      >
                        <span>
                          Create Template
                        </span>
                      </FlatButton>
                    </li> 
                  : null
                }

                {
                  this.allowed_menu['listFeedbackTemplate'] ? 
                    <li>
                      <FlatButton 
                        onClick={this._handleClick.bind(this)} 
                        className="prepend-icon" 
                        href="#/app/feedback/templates/list"
                      >
                        <span>
                          List Templates
                        </span>
                      </FlatButton>
                    </li> 
                  : null
                }
              </ul>
            </li> 
          : null
        }

        {
          this.allowed_menu['users'] ? 
            <li>
              <FlatButton 
                onClick={this._handleClick.bind(this)} 
                href="#/app/users"
              >
                <i className="nav-icon material-icons">
                  person
                </i>

                <span className="nav-text">
                  Users
                </span>
              </FlatButton>
            </li> 
          : null
        }

        {
          this.allowed_menu['schedule'] ? 
            <li>
              <FlatButton onClick={this._handleClick.bind(this)} href="#/app/schedule">
                <i className="nav-icon material-icons">schedule</i>
                <span className="nav-text">Schedule</span>
              </FlatButton>
            </li> 
          : null
        }

        {          
          this.allowed_menu['smartlockcards'] ? 
            <li>
              <FlatButton 
                onClick={this._handleClick.bind(this)} 
                href="#/app/smartlockcards" 
              >
                <i className="nav-icon material-icons">
                  style
                </i>

                <span className="nav-text">
                  Smart Lock Cards
                </span>
              </FlatButton>
            </li> 
          : null
        }

        {
          this.allowed_menu['promotions'] ? 
            <li>
              <FlatButton 
                onClick={this._handleClick.bind(this)} 
                href="#/app/promos"
              >
                <i className="nav-icon material-icons">
                  chrome_reader_mode
                </i>
                
                <span className="nav-text">
                  Promotions
                </span>
              </FlatButton>
            </li> 
          : null
        }

        {
          this.allowed_menu['integration'] && 0 ? 
            <li>
              <FlatButton onClick={this._handleClick.bind(this)} href="#app/integration/generateToken">
                <i className="nav-icon material-icons">build</i>
                <span className="nav-text">
                  Api Integration
                </span>
              </FlatButton>
            </li> 
          : null
        }
      </ul>
    );
  }
}

module.exports = withRouter(SidebarContent);



// WEBPACK FOOTER //
// ./components/Sidenav/SidenavContent.js